
export default {
    getName: (state) => state.name,
    getNextSeqCode: (state) => state.nextSeqCode,

    getQhses: (state) => state.qhses,
}